// EmployeeCard.tsx
import React from "react";

import { Employee } from "0.Mine/3.Interfaces/Employee";

import { useEmployeeCardLogic } from "../Logic/EmployeeCard";
import { EmployeeCardUI } from "../UI/BusinessCard";

export interface EmployeeCardProps {
  employee: Employee;
  index: number;
  onUpdate: (employee: Employee) => void;
  onDelete: (employeeId: number) => void;
  onFileUpload: (employeeId: number, file: File) => void;
}

export const EmployeeCard: React.FC<EmployeeCardProps> = ({
  employee,
  index,
  onUpdate,
  onDelete,
  onFileUpload,
}) => {
  const {
    editing,
    editingData,
    expanded,
    startEditing,
    cancelEditing,
    saveEditing,
    toggleExpanded,
    handleDelete,
    handleEditingDataChange,
    handleScheduleChange,
  } = useEmployeeCardLogic({ employee, index, onUpdate, onDelete });

  return (
    <EmployeeCardUI
      employee={employee}
      index={index}
      editing={editing}
      editingData={editingData}
      expanded={expanded}
      startEditing={startEditing}
      cancelEditing={cancelEditing}
      saveEditing={saveEditing}
      toggleExpanded={toggleExpanded}
      handleDelete={handleDelete}
      handleEditingDataChange={handleEditingDataChange}
      handleScheduleChange={handleScheduleChange}
      handleFileUpload={onFileUpload}
    />
  );
};

export default React.memo(EmployeeCard);
